import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  DataApiResponse,
  MaccsBoxReportType,
  MaccsboxDefaults,
  MaccsboxReport,
  MaccsboxReportPreview,
  MaccsboxTickets,
} from '@digilize/shared/definitions/src';
import { Observable } from 'rxjs';

export interface MaccsboxTicketsParams {
  shop: string;
  type: MaccsBoxReportType;
  period_start: string;
}

@Injectable({ providedIn: 'root' })
export class MaccsboxReportsApiService {
  private readonly base = '/api/v1.0/maccsbox-reports';

  constructor(private http: HttpClient) {}

  getReports(params: Record<string, unknown>): Observable<DataApiResponse<MaccsboxReport[]>> {
    return this.http.get<DataApiResponse<MaccsboxReport[]>>(this.base, { params: params as any });
  }

  getReportPreview(id: string): Observable<MaccsboxReportPreview> {
    return this.http.get<MaccsboxReportPreview>(`${this.base}/${id}/preview`);
  }

  downloadReport(id: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.base}/${id}/download`, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  recreateReport(id: string): Observable<MaccsboxReport> {
    return this.http.post<MaccsboxReport>(`${this.base}/${id}/recreate`, {});
  }

  approveReport(id: string): Observable<MaccsboxReport> {
    return this.http.post<MaccsboxReport>(`${this.base}/${id}/approve`, {});
  }

  getTickets(params: MaccsboxTicketsParams): Observable<MaccsboxTickets> {
    return this.http.get<MaccsboxTickets>(`${this.base}/tickets`, {
      params: {
        shop: params.shop,
        type: MaccsBoxReportType[params.type],
        period_start: params.period_start,
      },
    });
  }

  // The period of getTickets as an xlsx workbook - same params, so the two calls agree by construction.
  exportTickets(params: MaccsboxTicketsParams): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.base}/tickets/export`, {
      params: {
        shop: params.shop,
        type: MaccsBoxReportType[params.type],
        period_start: params.period_start,
      },
      responseType: 'blob',
      observe: 'response',
    });
  }

  getDefaults(shop: string): Observable<MaccsboxDefaults> {
    return this.http.get<MaccsboxDefaults>(`${this.base}/defaults`, { params: { shop } });
  }

  resendReport(params: MaccsboxTicketsParams): Observable<void> {
    return this.http.post<void>(`${this.base}/resend`, {
      shop: params.shop,
      type: params.type,
      period_start: params.period_start,
    });
  }
}
